/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArgusAnimal } from '../../models/argus-animal';

export interface GetArgusAnimals$Params {
  id: string;
}

export function getArgusAnimals(http: HttpClient, rootUrl: string, params: GetArgusAnimals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArgusAnimal>>> {
  const rb = new RequestBuilder(rootUrl, getArgusAnimals.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArgusAnimal>>;
    })
  );
}

getArgusAnimals.PATH = '/api/customers/{id}/argus/animals';
